import React, { useEffect, useState } from 'react'
import './InitialAssessmentReport.css'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import { useParams } from 'react-router'

const InitialClaimReport = () => {
  const { claimNumber } = useParams()
  console.log('7', claimNumber)

  const navigate = useNavigate()

  const handleApproveClick = async () => {
    const statusUploadd = await axios.post(
      '/process_data/update_invoice_report',
      { claimNumber }
    )
    navigate(`/final-claim-report/${claimNumber}`)
  }
  const handleManualqcClick = () => {
    navigate(`/manual-qc-claim/${claimNumber}`)
  }

  const [data, setData] = useState(null)
  const [claimDataS3, setclaimDataS3] = useState(null)
  const [progressData, setProgressData] = useState({})
  const [claimData, setClaimData] = useState(null)

  useEffect(() => {
    const fetchClaimDetails = async () => {
      try {
        const res = await axios.post('/process_data/claim-data', { claimNumber })
        console.log('391', res.data)
        setClaimData(res.data)
      } catch (err) {
        console.error('Error fetching claim details:', err)
      }
    }
    if (claimNumber) {
      fetchClaimDetails()
    }
  }, [claimNumber])

  const formatDateTime = (dateString) => {
    if (!dateString) return '--'
    try {
      const date = new Date(dateString)
      if (isNaN(date)) return '--'
      const day     = String(date.getDate()).padStart(2, '0')
      const month   = String(date.getMonth() + 1).padStart(2, '0')
      const year    = date.getFullYear()
      const hours   = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`
    } catch (error) {
      console.error('Error formatting date:', error)
      return '--'
    }
  }

  useEffect(() => {
    const fetchProgress = async () => {
      if (claimNumber) {
        try {
          const res = await axios.post(`/process_data/claim_progress/${claimNumber}`)
          setProgressData(res.data)
          console.log('progress-32', res.data)
        } catch (err) {
          console.error('Error fetching claim progress:', err)
        }
      }
    }
    fetchProgress()
  }, [claimNumber])

  // useEffect(() => {
  //   if (!claimNumber || !progressData) return

  //   if (progressData.pre_invoice == '1') {
  //     console.log('43-pre-invoice-extract')
  //     axios
  //       .post(`/server/get-pre-invoice-data/${claimNumber}`)
  //       .then(response => {
  //         console.log('pre-invoice data', response.data)
  //         setData(response.data)
  //       })
  //       .catch(error => console.error('Axios error:', error))
  //   } else {
  //     console.log('54-invoice-extract')
  //     axios
  //       .post(`/server/get-invoice-data/${claimNumber}`)
  //       .then(response => {
  //         console.log('invoice data', response.data)
  //         setData(response.data)
  //       })
  //       .catch(error => console.error('Axios error:', error))
  //   }
  // }, [claimNumber, progressData])

  useEffect(() => {
  if (!claimNumber || !progressData) return

  const fetchData = async () => {
    // 🟢 Step 1: Try invoice
    if (progressData.invoice == '1') {
      try {
        console.log('Trying invoice...')
        const res = await axios.post(`/server/get-invoice-data/${claimNumber}`)
        setData(res.data)
        return
      } catch (err) {
        console.log('Invoice failed, falling back to pre-invoice')
      }
    }

    // 🟡 Step 2: fallback to pre-invoice
    if (progressData.pre_invoice == '1') {
      try {
        const res = await axios.post(`/server/get-pre-invoice-data/${claimNumber}`)
        setData(res.data)
      } catch (err) {
        console.error('Pre-invoice also failed:', err)
      }
    }
  }

  fetchData()
}, [claimNumber, progressData])

  useEffect(() => {
    if (claimNumber) {
      axios
        .post(`/server/get-claim-data/${claimNumber}`)
        .then(response => {
          console.log('claimDataS3', response.data)
          setclaimDataS3(response.data)
        })
        .catch(error => console.error('Axios error:', error))
    }
  }, [claimNumber])

  // Plain amount formatter (no ₹ symbol) — for subtotal row
  const formatAmount = value => {
    const num = Number(value)
    return isNaN(num) ? '0.00' : num.toFixed(2)
  }

  // Full formatter with ₹ — handles "Not Found" / null / undefined gracefully
  const fmt = value => {
    if (value === 'Not Found' || value === null || value === undefined) return '--'
    const num = Number(value)
    return isNaN(num) ? '--' : `₹${num.toFixed(2)}`
  }

  // JSON structure: response.data = { data: { parts_details: [...], labour_details: [...], ... } }
  const rawData = data?.data || data || {}

  const combinedData = {
    ...(claimDataS3 || {}),
    ...rawData,
    // map parts_details → parts
    parts: rawData.parts_details || rawData.parts || [],
    // final_calculation assembled from top-level fields
    final_calculation: {
      total_liability:       rawData.total_liability,
      compulsory_deductable: rawData.compulsory_deductable,
      voluntary_deductible:  rawData.voluntary_deductible,
      salvage_deductions:    rawData.salvage_amount,
      non_standard_amount:   rawData.non_standard_amount,
      towing_amount:         rawData.towing_amount,
      digit_liability:       rawData.digit_liability,
    },
  }
  console.log('combinedData', combinedData)

  if (!data || !claimDataS3) return <div>Loading...</div>

  return (
    <div className='report-container'>
      <div className='report-header'>
        <img
          src='/custom-icons/surveyorIcon.png'
          alt='Surveyor AI Logo'
          className='logo'
        />
        <div className='report-title'>
          <h2>Initial Claim Assessment Report</h2>
        </div>
        <p className='printed-date'>
          Printed:{' '}
          {new Date().toLocaleDateString('en-IN', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
          })}
        </p>
      </div>

      <div className='inline-box-row'>
        <div className='inline-box label'>Policy Number</div>
        <div className='inline-box value'>{combinedData.policyNumber || '--'}</div>
        <div className='inline-box label'>Claim Number</div>
        <div className='inline-box value'>{combinedData.claimNumber || '--'}</div>
        <div className='inline-box label'>Ticket Number</div>
        <div className='inline-box value'>{combinedData?.workshop_details?.ticket_number || '--'}</div>
      </div>

      <div className='inline-box-row info-box'>
        <div className='info-full-row'>
          <div className='inline-box label'>Date:{formatDateTime(new Date())}</div>
          <div className='inline-box value'>{claimData?.date || '--'}</div>
        </div>

        <div className='info-row'>
          <div className='inline-box label'>Name of Owner:</div>
          <div className='inline-box value'>{combinedData?.insured || claimData?.customer_name || '--'}</div>
          <div className='inline-box label'>Engine No.:</div>
          <div className='inline-box value'>{combinedData?.EngineNumber || claimData?.engine_number || '--'}</div>
          <div className='inline-box label'>Workshop Name:</div>
          <div className='inline-box value'>{claimData?.workshop_name || '--'}</div>
        </div>

        <div className='info-row'>
          <div className='inline-box label'>Registration No.:</div>
          <div className='inline-box value'>{claimData?.vehicle_number || '--'}</div>
          <div className='inline-box label'>Surveyor Name:</div>
          <div className='inline-box value'>Surveyor's Ai</div>
          <div className='inline-box label'>Workshop GST Number:</div>
          <div className='inline-box value'>{claimData?.workshop_gst || '--'}</div>
        </div>

        <div className='info-row'>
          <div className='inline-box label'>Date of Reg.:</div>
          <div className='inline-box value'>{formatDateTime(combinedData?.DateofRegistration)}</div>
          <div className='inline-box label'>Claim Coordinator:</div>
          <div className='inline-box value'>{claimData?.claimCoordinator || '--'}</div>
          <div className='inline-box label'>Date of Accident:</div>
          <div className='inline-box value'>{formatDateTime(claimData?.accident_datetime)}</div>
        </div>

        <div className='info-row'>
          <div className='inline-box label'>Make & Model:</div>
          <div className='inline-box value'>
            {claimData?.make || ''} {claimData?.model || '--'}{' '}
            {claimData?.variant || '--'}
          </div>
          <div className='inline-box label'>Chassis No.:</div>
          <div className='inline-box value'>
            {combinedData?.ChassisNumber || claimData?.chassis_number || '--'}
          </div>
          <div className='inline-box label'>Vehicle Age (Years):</div>
          <div className='inline-box value'>
            {(() => {
              const regDateRaw  = combinedData?.DateofRegistration
              const accidentRaw = claimData?.accident_datetime
              if (regDateRaw && accidentRaw) {
                const regDate      = new Date(regDateRaw)
                const accidentDate = new Date(accidentRaw)
                if (!isNaN(regDate) && !isNaN(accidentDate)) {
                  let years  = accidentDate.getFullYear() - regDate.getFullYear()
                  let months = accidentDate.getMonth()    - regDate.getMonth()
                  let days   = accidentDate.getDate()     - regDate.getDate()
                  if (days < 0) {
                    months -= 1
                    days   += new Date(accidentDate.getFullYear(), accidentDate.getMonth(), 0).getDate()
                  }
                  if (months < 0) { years -= 1; months += 12 }
                  years = Math.max(years, 1)
                  return `${years} Years ${months} Months`
                }
              }
              return '--'
            })()}
          </div>
        </div>

        <div className='info-row'>
          <div className='inline-box label'>Payment to:</div>
          <div className='inline-box value'>Workshop</div>
        </div>
      </div>

      <div className='note-section'>
        <p>
          "Please find the below tentative estimation for the subject vehicle as
          per the visible damages..."
        </p>
        <p><strong>Important Notes:</strong></p>
        <ul>
          <li>After completion of repair, you shall submit the vehicle for reinspection...</li>
          <li>Final tax invoice raised in favor of Surveyor Insurance Limited...</li>
        </ul>
        <p className='help-note'>
          For any further clarifications regarding your claim: Contact TPA at&nbsp;
          {'surveyor@surveyor.com'} or {' +91-9876543210'}
        </p>
      </div>

      <h4 className='section-heading'>PARTS</h4>
      <table className='parts-table'>
        <thead>
          <tr>
            <th>SN</th>
            <th>JOB</th>
            <th>MATERIAL</th>
            <th>DESCRIPTION</th>
            <th>HSN</th>
            <th>QTY</th>
            <th>PART RATE</th>
            <th>TAXABLE AMOUNT</th>
            <th>TAX (%)</th>
            <th>TAX AMOUNT</th>
            <th>TOTAL AMOUNT</th>
            <th>DEP (%)</th>
            <th>DEP AMOUNT</th>
            <th>R&amp;R CHARGES</th>
            <th>REPAIR CHARGES</th>
            <th>PAINTING CHARGES</th>
          </tr>
        </thead>
        <tbody>
          {combinedData?.parts?.length > 0 ? (
            combinedData.parts.map((part, i) => {
              const rawQty      = Number(part.quantity)
              const qty         = rawQty > 0 ? rawQty : 1           // default 1 if missing
              const TAX_PERCENT = 18                                 // always 18%

              // PART RATE = taxable_amount value from JSON
              const partRate    = Number(part.taxable_amount) || 0

              // TAX AMOUNT = partRate * 18 / 100
              const taxAmount   = parseFloat((partRate * TAX_PERCENT / 100).toFixed(2))

              // TOTAL AMOUNT = partRate + taxAmount
              const totalAmount = parseFloat((partRate + taxAmount).toFixed(2))

              // DEP % from dep_percentage field
              const depPercent  = part.dep_percentage !== '' && part.dep_percentage != null
                                    ? Number(part.dep_percentage)
                                    : '--'

              // DEP AMOUNT from dep_amount field
              const depAmt      = part.dep_amount !== '' && part.dep_amount != null
                                    ? Number(part.dep_amount)
                                    : null

              return (
                <tr key={i}>
                  <td>{i + 1}</td>
                  <td>{part.job || part.decision || '--'}</td>
                  <td>{part.material || '--'}</td>
                  <td>{part.description || '--'}</td>
                  <td>{part.hsn_code || '--'}</td>
                  <td>{qty}</td>
                  <td>{partRate.toFixed(2)}</td>                    {/* PART RATE = taxable_amount */}
                  <td>{partRate.toFixed(2)}</td>                    {/* TAXABLE AMOUNT = taxable_amount */}
                  <td>{TAX_PERCENT}</td>                            {/* TAX (%) always 18 */}
                  <td>{taxAmount.toFixed(2)}</td>                   {/* TAX AMOUNT = taxable * 18% */}
                  <td>{totalAmount.toFixed(2)}</td>                 {/* TOTAL = taxable + tax */}
                  <td>{depPercent}</td>                             {/* DEP % from dep_percentage */}
                  <td>{depAmt != null ? depAmt.toFixed(2) : '--'}</td>  {/* DEP AMOUNT from dep_amount */}
                  <td>{fmt(part.r_and_r_charges)}</td>
                  <td>{fmt(part.repair_charges)}</td>
                  <td>{fmt(part.painting_charges)}</td>
                </tr>
              )
            })
          ) : (
            <tr>
              <td colSpan='16'>No parts details available</td>
            </tr>
          )}

          {/* Subtotal Row — calculated from per-row computed values */}
          {combinedData?.parts?.length > 0 && (() => {
            const subTaxable = combinedData.parts.reduce((sum, p) => sum + (Number(p.taxable_amount) || 0), 0)
            const subTax     = parseFloat((subTaxable * 18 / 100).toFixed(2))
            const subTotal   = parseFloat((subTaxable + subTax).toFixed(2))
            const subDep     = combinedData.parts.reduce((sum, p) => sum + (Number(p.dep_amount) || 0), 0)
            return (
              <tr className='subtotal-row'>
                <td colSpan='7'><strong>Subtotal</strong></td>
                <td>{subTaxable.toFixed(2)}</td>   {/* sum of taxable_amount */}
                <td></td>
                <td>{subTax.toFixed(2)}</td>        {/* sum taxable * 18% */}
                <td>{subTotal.toFixed(2)}</td>      {/* taxable + tax */}
                <td></td>
                <td>{subDep.toFixed(2)}</td>        {/* sum dep_amount */}
                <td colSpan='3'></td>
              </tr>
            )
          })()}
        </tbody>
      </table>

      <h4 className='section-heading'>LABOUR</h4>
      <table className='labor-table'>
        <thead>
          <tr>
            <th>LABOUR TYPE</th>
            <th>TAXABLE AMOUNT</th>
            <th>TAX AMOUNT</th>
            <th>TOTAL AMOUNT</th>
            <th>DEP AMOUNT</th>
          </tr>
        </thead>
        <tbody>
          {combinedData?.labour_details?.length > 0 ? (
            combinedData.labour_details.map((labour, index) => (
              <tr key={index}>
                <td>{labour.labour_type === 'Not Found' ? '--' : (labour.labour_type || '--')}</td>
                <td>{fmt(labour.taxable_amount)}</td>
                <td>{fmt(labour.tax_amount)}</td>
                <td>{fmt(labour.total_amount)}</td>
                <td>{fmt(labour.dep_amount)}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan='5'>No labour details available</td>
            </tr>
          )}
        </tbody>
      </table>

      <h4 className='section-heading'>FINAL CALCULATION</h4>
      {(() => {
        const parts = combinedData?.parts || []
        const labour = combinedData?.labour_details || []

        // Parts total = sum of (taxable_amount + taxable_amount * 18%)
        const partsTotalAmount = parts.reduce((sum, p) => {
          const taxable = Number(p.taxable_amount) || 0
          const tax     = taxable * 18 / 100
          return sum + taxable + tax
        }, 0)

        // Labour total = sum of total_amount (only valid numbers, skip "Not Found")
        const labourTotalAmount = labour.reduce((sum, l) => {
          const v = Number(l.total_amount)
          return sum + (isNaN(v) ? 0 : v)
        }, 0)

        const totalLiability       = parseFloat((partsTotalAmount + labourTotalAmount).toFixed(2))
        const compulsoryDeductible = 1000
        const insurerLiability     = parseFloat((totalLiability - compulsoryDeductible).toFixed(2))

        return (
          <table className='final-table'>
            <thead>
              <tr>
                <th>FINAL CALCULATION</th>
                <th>AMOUNT</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Total Liability</td>
                <td>{totalLiability.toFixed(2)}</td>
              </tr>
              <tr>
                <td>Compulsory Deductible</td>
                <td>{compulsoryDeductible.toFixed(2)}</td>
              </tr>
              <tr>
                <td>Voluntary Deductible</td>
                <td>{combinedData?.final_calculation?.voluntary_deductible || '0.00'}</td>
              </tr>
              <tr>
                <td>Salvage Deductions</td>
                <td>{combinedData?.final_calculation?.salvage_deductions || '0.00'}</td>
              </tr>
              <tr>
                <td>Non-Standard Amount</td>
                <td>{combinedData?.final_calculation?.non_standard_amount || '0.00'}</td>
              </tr>
              <tr>
                <td>Towing Amount</td>
                <td>{combinedData?.final_calculation?.towing_amount || '0.00'}</td>
              </tr>
              <tr className='total-row'>
                <td>Insurer Liability</td>
                <td>{insurerLiability.toFixed(2)}</td>
              </tr>
            </tbody>
          </table>
        )
      })()}

      <div className='note-section'>
        <div className='section-heading'>ASSESSMENT NOTES</div>
        <ul className='assessment-notes'>
          <li>Any additional amount over and above the approved assessment shall be borne by the Insured.</li>
          <li>The final liability has been arrived at as full and final settlement after consent from the Insured...</li>
        </ul>
      </div>

      <div className='button-group'>
        <button className='approve-btn' onClick={handleApproveClick}>Approve</button>
        <button className='manual-btn' onClick={handleManualqcClick}>Manual QC</button>
      </div>
    </div>
  )
}

export default InitialClaimReport
